// @ts-nocheck
import psHttp, { RequestChannel, psHttp$ } from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix, passportApiUrlPrefix } from '@cores/constants/envConfig';
const fetchChannelWorkspace = new RequestChannel(psHttp$);
let defPsHttp = psHttp;
export function overwritePsHttp(psHttp) {
    defPsHttp = psHttp;
}
// #region  zyh
/**
 * 工作空间加密:获取公钥接口
 */
export function getPublicKeyApi() {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/lab/encryption/public-key`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function postWorkspaceEncryptionApi({ encryption_id, encryption_password, encryption_type = 'space', prompt }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/lab/encryption`,
        method: 'POST',
        data: {
            encryption_id,
            encryption_password,
            encryption_type,
            prompt,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 工作空间加密:工作空间取消密码
 */
export function postWorkspaceDecodeApi({ encryption_id, encryption_password, encryption_type = 'space' }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/lab/encryption`,
        method: 'DELETE',
        data: {
            encryption_id,
            encryption_password,
            encryption_type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 工作空间加密:工作空间加密接口
 */
export function decodeAndEncryptionApi({ encryption_id, encryption_password, encryption_type = 'space', prompt }, type) {
    if (type === 'encrypt') {
        return postWorkspaceEncryptionApi({ encryption_id, encryption_password, encryption_type, prompt });
    }
    return postWorkspaceDecodeApi({ encryption_id, encryption_password, encryption_type });
}
/**
 * 工作空间解密:解密接口，获取token
 */
export function postWorkspaceEncryptionTokenApi({ encryption_id, encryption_password, encryption_type = 'space' }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/lab/encryption/token`,
        method: 'POST',
        data: {
            encryption_id,
            encryption_password,
            encryption_type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
// #endregion
/**
 * 获取workspace
 *
 * @param {String} type 类型，【自己的(self)，分享的(shared), 所有的(all)】
 */
export function getWorkspacesByTypeApi(type = 'self', { sort_type, has_share_permission, label_id, search_name } = {}) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space`,
        method: 'GET',
        params: {
            type,
            sort_type,
            label_id,
            search_name,
            has_share_permission,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 获取workspace V2
 *
 * @param {String} type 类型，【自己的(self)，分享的(shared), 企业的(public), 所有的(all)】
 */
export function getWorkspacesByTypeV2Api(type = 'all', { sort_type, label_name, search_name, page, limit } = {}) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/list`,
        method: 'POST',
        data: {
            type,
            sort_type,
            label_name,
            search_name,
            page,
            limit,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 搜索工作空间(建议)
 *
 * space_type: self share
 */
export function getSimpleWorkspacesByTypeApi({ type, sort_type }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/search/space`,
        method: 'GET',
        params: {
            type,
            sort_type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data || {};
    });
}
/**
 * 获取workspace add limit 数据
 *
 */
export function getWorkspacesCreateLimitApi() {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/limit`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 删除分享的workspace
 * @param {string} space_id 工作空间id
 */
export function rejectShareWorkspaceApi(space_id) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/${space_id}/reject-share`,
        method: 'DELETE',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 批量退出分享的workspace
 */
export function batchRejectShareWorkspaceApi(data) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/batch-reject-share`,
        method: 'DELETE',
        data: data,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 上传workspace图标
 * @param {Object} param 参数
 * @param {string} param.poster 图片文件Base64
 */
export function uploadWorkspaceIconApi({ poster }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space-icon`,
        method: 'POST',
        data: { poster },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 分享workspace
 * @param {*} param0
 */
export function shareWorkspaceApi({ space_id, lang, share_permissions, delete_emails }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/${space_id}/share`,
        method: 'PUT',
        transformCode: true,
        data: {
            lang,
            share_permissions,
            delete_emails,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 分享多个workspace
 */
export function shareMultiWorkspacesApi({ add_permissions, update_permissions, delete_user_ids, share_spaces, space_id, }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/${space_id}/multi-share`,
        method: 'POST',
        transformCode: true,
        data: {
            add_permissions,
            update_permissions,
            delete_user_ids,
            share_spaces,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 获取当前分享过的用户邮箱地址
 * @param {*} param0
 */
export function getSharedUsersApi({ space_id }) {
    return defPsHttp({
        cache: false,
        url: `${workspaceApiUrlPrefix}/${space_id}/share-users`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || [];
    });
}
/**
 * 获取可分享的所有公司邮箱地址
 * @param {*} param0
 */
export function getSharedCompanyEmailApi({ cache } = { cache: false }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/company-email`,
        method: 'GET',
        transformCode: true,
        cache,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function getSuggestionEmailApi({ page = 0, limit = 20, name, cache = false, with_tenant = false, }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/email/think`,
        method: 'GET',
        params: {
            page,
            limit,
            name,
            with_tenant,
        },
        transformCode: true,
        cache,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function checkWorkspaceRoleApi({ user_id }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/email/check-workspace-role`,
        method: 'GET',
        params: { user_id },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 更新workspace访问时间
 * @param {string} param.space_id 工作空间标识
 */
export function accessTsWorkspaceApi({ space_id }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/access`,
        method: 'POST',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 获取workspace设置
 * @param {string} param.space_id 工作空间标识
 */
export function getWorkspaceSettingApi({ space_id }, params = {}) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/setting`,
        method: 'GET',
        params,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 更新workspace设置
 * @param {string} param.space_id 工作空间标识
 *  * @param {string} param.collapse 结果显示选项
 *  * @param {string} param.display_charts 分析概览图表显示设置
 *  * @param {string} param.display_fields 字段显示设置
 *  * @param {string} param.family_country 专利族标签
 *  * @param {string} param.rows 每页数量
 *  * @param {string} param.sort 排序方式
 *  * @param {string} param.stem 即将废弃
 */
export function updateWorkspaceSettingApi({ space_id, collapse, display_charts, display_fields, family_country, family_tag, rows, sort, paper_sort, common_sort, stem, }, params = {}) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/setting`,
        method: 'PUT',
        data: {
            collapse,
            display_charts,
            display_fields,
            family_country,
            family_tag,
            rows,
            sort,
            paper_sort,
            common_sort,
            stem,
        },
        params,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function updateWorkspaceCollapseSettingApi({ space_id, collapse, }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/collapse`,
        method: 'PUT',
        data: {
            collapse,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 获取workspace过滤左侧字段排序
 * @param {string} param.space_id 工作空间标识
 */
export function getSpaceFilterSortApi({ space_id, folder_id = undefined }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/filter-sort`,
        method: 'GET',
        params: { folder_id },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 保存workspace过滤左侧字段排序
 */
export function saveSpaceFilterSortApi({ space_id, folder_id = undefined, filter_items = [] }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/filter-sort`,
        method: 'POST',
        params: { folder_id },
        data: filter_items,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 获取workspace默认过滤左侧字段排序
 */
export function getSpaceDefaultFilterSortApi({ space_id }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/default-filter-sort`,
        method: 'GET',
        params: { space_id },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 查询folder
 */
export function searchWorkspaceSelfShareApi({ need_share_space, skip_count, patent_read_only, folder_search_name, need_public_space = true, data_type, }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/self-share-search`,
        method: 'GET',
        params: { need_share_space, skip_count, patent_read_only, folder_search_name, need_public_space, data_type },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 获取当前workspace下folder的信息
 */
export function getFolderInfoByIdApi({ space_id, folder_id }) {
    return defPsHttp({
        cache: false,
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}/init`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 设置行高
 */
export function setRowHeightSettingApi({ setting = 'auto' }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/row-height-setting`,
        method: 'PUT',
        params: { setting },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function transferAdminListApi(spaceId) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/tenant/space/${spaceId}/administrator/list`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function transferPublicAuthApi(spaceId, user_ids) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/tenant/space/${spaceId}/manage/authority`,
        method: 'PUT',
        transformCode: true,
        data: {
            user_ids,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function clearTransferNotificationApi(type, spaces) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/deliver/notification`,
        method: 'POST',
        data: {
            space_ids: spaces,
            type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function transferWorkspaceApi({ dst_user_id, need_comment, need_email_alert, need_field, spaces, to_company_space }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/transfer`,
        method: 'POST',
        params: {},
        data: {
            dst_user_id,
            need_comment,
            need_email_alert,
            need_field,
            spaces,
            to_company_space,
            type: 'transfer',
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function getWorkspaceLabel(type) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/workspace/label?type=${type}`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || [];
    });
}
export function createWorkspaceLabel(labelName) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/workspace/label`,
        method: 'POST',
        params: {},
        data: labelName,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function updateWorkspaceLabel({ label_id, label_name }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/workspace/label/${label_id}`,
        method: 'PUT',
        params: {},
        data: {
            label_name,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function deleteWorkspaceLabel(labelId) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/workspace/label/${labelId}`,
        method: 'DELETE',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function getWorkspaceLabelStatistics({ search_name }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/workspace/label/statistics`,
        method: 'GET',
        params: { search_name },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || [];
    });
}
/**
 * 获取清理脏数据提示flag
*/
export function getCleanDeletedGuide() {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/patents/show-clean-deleted-guide`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || false;
    });
}
/**
 * 设置清理脏数据提示flag
 */
export function putCleanDeletedGuide({ clean = false }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/patents/clean-deleted`,
        method: 'PUT',
        params: { clean },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 获取所有的工作空间
 */
export function getAllWorkspace({ need_share_space, need_public_space, folder_search_name, data_type, operate_type = 'ADD', }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/self-share-public`,
        method: 'POST',
        data: {
            need_share_space,
            need_public_space,
            folder_search_name,
            data_type,
            operate_type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 获取搜索文件结果
 */
export function getSearchFolderResult({ space_id, folder_search_name, just_check_read_patent_permit }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/search-folder`,
        method: 'POST',
        data: {
            space_id,
            folder_search_name,
        },
        params: {
            just_check_read_patent_permit,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 更新同族状态
 * @param {*} param0
 * @returns
 */
export function updateSpaceCollapseApi({ space_id, payload }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/collapse`,
        method: 'PUT',
        transformCode: true,
        data: payload,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
* workspace用户卡片 样本工作空间
*/
export function getSampleSpaceApi() {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/on-boarding/sample-space`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
* workspace用户卡片 保存样本工作空间
*/
export function saveSampleSpaceApi({ sample_field_ids, sample_folder_ids, sample_space_id, space_icon, space_name, }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/on-boarding/sample-space-copy`,
        method: 'POST',
        data: {
            sample_field_ids,
            sample_folder_ids,
            sample_space_id,
            space_icon,
            space_name,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || '';
    });
}
/**
* 最近访问的工作空间
*/
export function getRecentWorkspacesApi() {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/all-recent-spaces`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 申请分享码
 * @param {*} space_id_list
 * @returns
 */
export function requestShareCodeApi({ space_id_list = [] }) {
    return fetchChannelWorkspace
        .requestAsPromise({
        url: `${workspaceApiUrlPrefix}/share-code`,
        method: 'POST',
        data: { space_id_list },
        transformCode: true,
        // @ts-ignore
    }).then(({ data }) => {
        return data || {};
    });
}
/**
 * 使用分享码
 * @param {*} share_code
 * @returns
 */
export function useShareCodeApi({ share_code }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/share-code/${share_code}`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 清理删除掉的专利数据
 * @param {*} param0
 * @returns
 */
export function cleanDeletedPatentsApi({ folder_id = '' }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/clean-deleted-patents`,
        method: 'POST',
        transformCode: true,
        data: {},
    }).then(({ data }) => {
        return data.data || 0;
    });
}
/**
 * 获取self or public的工作空间
 */
export function getSelfOrPublicWorkspaceApi({ convert_query_type, folder_search_name, }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/query/self-or-public`,
        method: 'POST',
        data: {
            convert_query_type,
            folder_search_name,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function getGoWhereSettingApi() {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/user/setting/view/go-where`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function postGoWhereSettingApi({ should_go_where = 'none' }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/user/setting/view/go-where`,
        method: 'POST',
        data: {
            should_go_where,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 获得space上的协作人员
 * @param {*} param0
 * @returns
 */
export function getSpaceCollaborationMemberApi({ space_id, name = '' }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/collaboration-member`,
        method: 'GET',
        params: {
            name,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 获得folder上的协作人员
 * @param {*} param0
 * @returns
 */
export function getSpaceFolderCollaborationMemberApi({ space_id, folder_id, name = '' }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}/collaboration-member`,
        method: 'GET',
        params: {
            name,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 分页获取分组人员
 * @param {*} share_type SPACE | FOLDER
 * @param {*} share_id space_id | folder_id
 * @returns
 */
export function getGroupCollaborationMemberApi({ group_id, share_type, share_id, page = 1, limit = 20, name = '' }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/group/${group_id}/collaboration-member`,
        method: 'GET',
        params: {
            share_type,
            share_id,
            page,
            limit,
            name,
        },
        cache: true,
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 按照空间获取文件夹
 */
export function getSpaceCollaborationFolderApi({ space_id, name = '' }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/collaboration-folder-list`,
        method: 'GET',
        params: {
            name,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 修改权限
 * @param {*} param0
 * @returns
 */
export function changeMultiShareApi(data) {
    const { space_id, share_type, share_ids, add_permissions, delete_receiver_ids, update_permissions: updatePermissions } = data;
    const update_permissions = updatePermissions?.map(item => {
        return {
            // @ts-ignore
            ...item,
            // @ts-ignore
            user_role: item.user_role.toLocaleLowerCase(),
        };
    });
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/${space_id}/multi-share`,
        method: 'POST',
        data: {
            share_type,
            share_ids,
            add_permissions,
            delete_receiver_ids,
            update_permissions,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 判断是否是免费用户
 * @returns free_user
 */
export function getFreeShareInitApi({ space_id, folder_id, share_code }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/free-share/init`,
        method: 'GET',
        headers: {
            'X-API-Version': '2.0',
        },
        params: {
            space_id,
            folder_id,
            share_code,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 切换免费分享状态
 */
export function changeFreeShareApi({ share_type, share_id, share_status }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/free-share/switch`,
        method: 'PUT',
        data: {
            share_type,
            share_id,
            share_status,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 获取模版字段设置
 * @param {*} space_id
 * @returns
 */
export function getCurrentFieldSettingApi({ space_id, field_template_id = '' }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/current-field-setting`,
        method: 'GET',
        params: {
            field_template_id,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 获取字段设置
 * @param {*} param0
 * @returns
 */
export function getFieldSettingApi({ space_id, data_type, view_type }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/field-setting`,
        method: 'GET',
        params: {
            data_type,
            view_type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 更新空间字段设置
 * @param {*} param0
 * @returns
 */
export function updateSpaceFieldSettingApi({ space_id, field_template_id, need_update_field_template, field_setting, apply_to_all_folder, }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/field-setting`,
        method: 'POST',
        data: {
            field_template_id,
            need_update_field_template,
            field_setting,
            apply_to_all_folder,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 更新模板字段
 * @param {*} param0
 * @returns
 */
export function updateTemplateSettingApi({ field_template_id, field_setting, space_id, }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space-field-template/${field_template_id}`,
        method: 'PUT',
        data: {
            field_setting,
            space_id,
        },
        transformCode: true,
    }).then(({ data, }) => {
        return data.data;
    });
}
/**
 * 获取字段模版列表
 * @param {*} param0
 * @returns
 */
export function getSpaceFieldTemplateListApi({ space_id }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space-field-template-list`,
        method: 'GET',
        params: {
            space_id,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 保存模版
 * @param {*} param0
 * @returns
 */
export function saveSpaceFieldTemplateApi({ space_id, field_template_name, field_setting }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space-field-template`,
        method: 'POST',
        data: {
            space_id,
            field_template_name,
            field_setting,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 删除字段模版
 * @param {*} param0
 * @returns
 */
export function deleteFieldTemplateApi({ space_id, field_template_id }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space-field-template/${field_template_id}`,
        method: 'DELETE',
        params: {
            space_id,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
export function getAccessInfoApi(spaceId, folderId) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/user/access/info`,
        method: 'GET',
        params: {
            space_id: spaceId,
            folder_id: folderId,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 切换租户
 * @param {*} param0
 * @returns
 */
export function switchTenantApi({ client_id, from, individual, tenant_id }) {
    return defPsHttp({
        url: `${passportApiUrlPrefix}/switch-tenant`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        params: {
            client_id,
            from,
            individual,
            tenant_id,
        },
        withCredentials: true,
    }).then(({ data }) => {
        return data.data;
    });
}
/**
 * 检查字段是否可用
 * @returns
 */
export function postCheckFieldTemplateApi({ create_space_type, space_id, field_template_id, }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space-field-template/check-field`,
        method: 'POST',
        data: {
            create_space_type,
            space_id,
            field_template_id,
        },
    }).then(({ data, }) => {
        return data.data;
    });
}
export function updateSettingRowValueApi({ space_id, rows = 20 }) {
    return defPsHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/setting-row`,
        method: 'PUT',
        data: {
            rows,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
